var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGunSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-gun-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.667,
    viewBox: "0 0 24 18.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gun-solid",
    d: "M22.667,33.333H22V33a1,1,0,0,0-2,0v.333H1.8a1.8,1.8,0,0,0-1.8,1.8v3.736a1.8,1.8,0,0,0,1.8,1.8,1.333,1.333,0,0,1,1.282,1.7l-1.7,6.6a1.334,1.334,0,0,0,1.282,1.7H6.993A1.333,1.333,0,0,0,8.275,49.7l1.159-4.366h3.941a2.331,2.331,0,0,0,2.214-1.595l1.02-3.072h1.5a1.334,1.334,0,0,0,.943-.391L20,39.333h2.667A1.333,1.333,0,0,0,24,38V34.667A1.333,1.333,0,0,0,22.667,33.333Zm-8.979,9.775a.333.333,0,0,1-.317.225H9.963l.7-2.667H14.5ZM20,37.333H2.667V36H20Z",
    transform: "translate(0 -32)",
    fill: "#146f62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGunSolid);
export default __webpack_public_path__ + "static/media/ic-gun-solid.6d79cf6a9bd206a57febc106c6061dd9.svg";
export { ForwardRef as ReactComponent };